<template>
  <div class="full" ref="toucher">
    <BGTemplate class="full" @ready="engine = $event" :toucher="toucher"></BGTemplate>
    <RocketOne v-if="engine" :engine="engine" :scene="engine.scene"></RocketOne>
  </div>
</template>

<script>
export default {
  components: {
    RocketOne: require('./RocketOne.vue').default,
    BGTemplate: require('./BGTemplate.vue').default
  },
  data () {
    return {
      toucher: false,
      engine: false
    }
  },
  mounted () {
    this.toucher = this.$refs['toucher']
  }
}
</script>

<style>

</style>
